// https://momentjs.com/docs
import moment from 'moment';

/**
 * Verifies if two dates are in the same by comparing the day
 * Accepts JS Date objects or string in ISO 8601 format.
 *
 * @private
 * @param {String|Object} firstDate
 * @param {String|Object} secondDate
 * @return {Boolean}
 */
export default function isSameDate(firstDate, secondDate = new Date(), unit = 'day') {
  return moment(firstDate).isSame(secondDate, unit);
}
